import { c as _c } from "react/compiler-runtime";
import { IcoMegaphone16 } from '@onefootprint/icons';
import { Button, Popover } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import type { ComponentPropsWithRef } from 'react';
import { useTranslation } from 'react-i18next';
import useBrowserNotifications from '@/hooks/use-browser-notifications';
import useEnableNotifications from '../../../hooks/use-enable-notifications';
type NotificationsPopoverContentProps = {
  onAllow: () => void;
} & ComponentPropsWithRef<'div'>;
export const NotificationsPopoverContent = t0 => {
  const $ = _c(28);
  let className;
  let onAllow;
  let props;
  if ($[0] !== t0) {
    ({
      onAllow,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onAllow;
    $[3] = props;
  } else {
    className = $[1];
    onAllow = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "floatingChat.notifications.nudge"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[5] !== className) {
    t2 = cx("flex flex-col gap-3 p-4 max-w-[280px]", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t(_temp);
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <p className="text-label-3 text-primary">{t3}</p>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t(_temp2);
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <p className="text-body-3 text-tertiary">{t5}</p>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div>{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t(_temp3);
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== onAllow || $[21] !== t8) {
    t9 = <Button size="compact" onClick={onAllow}>{t8}</Button>;
    $[20] = onAllow;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== props || $[24] !== t2 || $[25] !== t7 || $[26] !== t9) {
    t10 = <div {...props} className={t2}>{t7}{t9}</div>;
    $[23] = props;
    $[24] = t2;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
type NotificationsHeaderButtonProps = {
  className?: string;
};
const NotificationsHeaderButton = t0 => {
  const $ = _c(14);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "floatingChat.notifications"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    permission,
    nudgeDismissed
  } = useBrowserNotifications();
  const {
    enable
  } = useEnableNotifications();
  if (permission !== "default" || nudgeDismissed) {
    return null;
  }
  let t2;
  if ($[1] !== enable) {
    t2 = <NotificationsPopoverContent onAllow={enable} />;
    $[1] = enable;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp4);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className) {
    t4 = cx(className, "max-md:hidden");
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoMegaphone16 />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4) {
    t6 = <button type="button" aria-label={t3} className={t4}>{t5}</button>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <Popover side="bottom" align="end" sideOffset={8} content={t2}>{t6}</Popover>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default NotificationsHeaderButton;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.body;
}
function _temp3($_1) {
  return $_1.allow;
}
function _temp4($) {
  return $.nudge.title;
}